import { supabase } from '../supabaseClient';

async function getAllUnits(launchId) {
    const { data, count, error } = await supabase.from('LaunchInventoryRelations').select('*,unitId(*,projectId(*),inventoryStatusId(*),inventoryTypeId(*)),wingId(*),launchId(*,eventId(*))')
        .eq('launchId', launchId)
    if (data) return { data, count };
    else throw error;
}

async function getAllUnitsByWings(launchId, wingId, projectId) {
    if (launchId) {
        let query;
        query = supabase
            .from('LaunchInventoryRelations')
            .select(
                '*,unitId(*,projectId(*),inventoryStatusId(*),inventoryTypeId(*)),wingId(*),launchId(*,eventId(*))'
            );
        if (launchId === 'All') {
            const launchIds = JSON.parse(sessionStorage.getItem('selectedLaunches'));
            query = query.in('launchId', launchIds);
        } else {
            query = query.eq('launchId', launchId);
        }
        if (wingId === 'All') {
            const wingIds = JSON.parse(sessionStorage.getItem('selectedWings'));
            query = query.in('wingId', wingIds);
        } else {
            query = query.eq('wingId', wingId);
        }
        const { data, count, error } = await query;
        if (data) {
            return { data, count };
        } else throw error;
    } else {
        let query;
        query = supabase
            .from('ProjectInventoryRelations')
            .select('*,unitId(*,projectId(*),inventoryStatusId(*),inventoryTypeId(*)),wingId(*))', {
                count: 'exact',
            })
            .eq('projectId', projectId);
        if (wingId === 'All') {
            const wingIds = JSON.parse(sessionStorage.getItem('selectedWings'));
            query = query.in('wingId', wingIds);
        } else {
            query = query.eq('wingId', wingId);
        }
        const { data, count, error } = await query;
        if (data) {
            return { data, count };
        } else throw error;
    }
}

async function getUnitsOfLaunches1(launchId) {
    const { data, error, count } = await supabase
        .from('LaunchInventoryRelations')
        .select("* , unitId(* , inventoryStatusId(*)), wingId(*) ", { count: 'exact' })
        .eq('launchId', launchId)
    if (data) return { data, count };
    else throw error;
}

export { getAllUnits, getAllUnitsByWings, getUnitsOfLaunches1 }